import * as React from 'react'

const PickupDropoffIndicatorIcon = (props: { className?: string }) => {
  return (
    <svg
      className={props.className}
      width='6'
      height='50'
      viewBox='0 0 6 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='3' cy='3' r='2.5' stroke='#D5D5D5' />
      <circle cx='3' cy='47' r='3' fill='#D5D5D5' />
      <circle cx='3' cy='10' r='1' fill='#D5D5D5' />
      <circle cx='3' cy='15' r='1' fill='#D5D5D5' />
      <circle cx='3' cy='20' r='1' fill='#D5D5D5' />
      <circle cx='3' cy='25' r='1' fill='#D5D5D5' />
      <circle cx='3' cy='30' r='1' fill='#D5D5D5' />
      <circle cx='3' cy='35' r='1' fill='#D5D5D5' />
      <circle cx='3' cy='40' r='1' fill='#D5D5D5' />
    </svg>
  )
}

export default PickupDropoffIndicatorIcon



// WEBPACK FOOTER //
// ./src/components/icons/trips/PickupDropoffIndicatorIcon.tsx